import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PlaybookList from "../features/playbook/components/PlaybookList";
import { PlaybookShort } from "../features/playbook/model/Playbook";
import { AddContextModal } from "../features/chat-management/components/AddContextModal";
import { AdditionalPlaybookParamsModal } from "../features/chat-management/components/AdditionalPlaybookParamsModal";
import { useRunPlaybook } from "../features/playbook/api/useRunPlaybook";
import ChatContext from "@/shared/models/ChatContext";

export default function Playbooks() {
  const navigate = useNavigate();
  const [activePlaybook, setActivePlaybook] = useState<PlaybookShort>();
  const [showContext, setShowContext] = useState(false);
  const [showAdditionalTextContext, setShowAdditionalTextContext] =
    useState(false);
  const [contextData, setContextData] = useState<ChatContext>();
  const { runPlaybook, chat } = useRunPlaybook();

  useEffect(() => {
    if (!chat) return;
    navigate(`/c/${chat.id}`);
  }, [chat, navigate]);

  const handlePlaybookSelect = async (playbook: PlaybookShort | undefined) => {
    setActivePlaybook(playbook);
    if (playbook) {
      setShowContext(true);
    }
  };

  const handleContextComplete = async (contextData: ChatContext) => {
    if (!activePlaybook) return;

    setContextData(contextData);
    setShowContext(false);
    setShowAdditionalTextContext(true);
  };

  const handleAdditionalTextContextComplete = async (
    additionalContext: string | undefined,
  ) => {
    if (!activePlaybook || !contextData) return;

    contextData.additionalContext = additionalContext;
    await runPlaybook(activePlaybook.id, contextData);
    setShowAdditionalTextContext(false);
    setActivePlaybook(undefined);
    setContextData(undefined);
  };

  return (
    <>
      <PlaybookList setActivePlaybook={handlePlaybookSelect} />
      {showContext && (
        <AddContextModal
          open={showContext}
          onClose={() => setShowContext(false)}
          onComplete={handleContextComplete}
          playbookId={activePlaybook?.id}
        />
      )}

      {/* Additional Text Context Modal */}
      <AdditionalPlaybookParamsModal
        open={showAdditionalTextContext}
        onClose={() => {
          setShowAdditionalTextContext(false);
          setActivePlaybook(undefined);
          setContextData(undefined);
        }}
        onComplete={handleAdditionalTextContextComplete}
      />
    </>
  );
}
